/**
 * Created by Mikhail Menshenin on 27.02.2025
 */

var VictoryMessageContentView = cc.Node.extend({
    ctor: function (message) {
        this._super();

        var styles = cleverapps.styles.VictoryMessageContentView;
        var options = {};
        if (cleverapps.styles.FONTS.GAME_MESSAGE_TEXT_VERTICAL) {
            options.font = cleverapps.resolution.mode === cleverapps.WideMode.VERTICAL ? cleverapps.styles.FONTS.GAME_MESSAGE_TEXT_VERTICAL : cleverapps.styles.FONTS.GAME_MESSAGE_TEXT;
        }
        var text = GameMessageView.createText(message, options);
        var textSize = styles.text.size[cleverapps.resolution.mode];
        text.fitTo(textSize.width);
        text.setAlignment(styles.text.position);
        this.addChild(text);

        var animation = VictoryMessageContentView.getAnimation();
        animation.setAlignment(styles.animation.position);
        animation.setLocalZOrder(2);
        this.addChild(animation);
        animation.setVisible(false);
        animation.runAction(new cc.Sequence(
            new cc.DelayTime(styles.animation.delay === undefined ? 0 : styles.animation.delay),
            new cc.Show(),
            new cc.SpineAction(animation, "animation")
        ));
    }
});

VictoryMessageContentView.getAnimation = function () {
    var json = bundles.gamemessage.jsons.victory_message_json;
    if (bundles.gamemessage.jsons.victory_message_vertical_json) {
        json = cleverapps.resolution.mode === cleverapps.WideMode.VERTICAL
            ? bundles.gamemessage.jsons.victory_message_vertical_json
            : json;
    }
    return new cleverapps.Spine(json);
};

VictoryMessageContentView.getAnimationDuration = function () {
    return VictoryMessageContentView.getAnimation().getAnimationDuration("animation");
};

cleverapps.styles.VictoryMessageContentView = {
    text: {
        size: [{
            width: 300,
            height: 300
        }, {
            width: 800,
            height: 120
        }, {
            width: 800,
            height: 120
        }],

        position: [{
            x: { align: "center", dx: 150 },
            y: { align: "center" }
        }, {
            x: { align: "center", dx: 100 },
            y: { align: "center" }
        }, {
            x: { align: "center", dx: 100 },
            y: { align: "center" }
        }]
    },

    animation: {
        position: [{
            x: { align: "center", dx: 210 },
            y: { align: "center" }
        }, {
            x: { align: "center" },
            y: { align: "center" }
        }, {
            x: { align: "center" },
            y: { align: "center" }
        }]
    }
};